import { Checkbox, BlockStack, Text, TextField, Divider, Button, Box, List, InlineError, Select, ChoiceList, InlineStack, RadioButton, Icon, Tooltip, Card } from '@shopify/polaris';
import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { DI } from '../../../../Core';
import Draggable from './DraggableOnboarding';
import { useTranslation } from 'react-i18next';
import { isSellerAlreadySelling } from '../onboardingApi';
import PreviousAppInfo from './PreviousAppInfo';
import { AlertMinor, InfoMinor } from '@shopify/polaris-icons';

const options = () => {
    const { t } = useTranslation();
    let opt: any = [
        { label: t('Select..'), value: '', disabled: true },
        { label: t('Yes'), value: "registered" },
        { label: t('No'), value: "not_registered" },
    ];
    return { optionsOpt: opt }
}

function Stepthree(props: any): ReactElement {
    const { t } = useTranslation();
    const { optionsOpt } = options();
    const [selectVal, setSelectVal] = useState<string>('registered');
    const [selectedReason, setSelectedReason] = useState<string[]>(['not_applied']);

    useEffect(() => {
        checkIsSellerAlreadySelling()
    }, [])

    useEffect(() => {
        if (selectVal !== '') {
            props?.updateState('brand_registered', "value", "", selectVal)
            selectVal === "registered" && props?.updateState('brand_registered', "reason", "", "")
            selectVal === "not_registered" && props?.updateState('brand_registered', "brand_name", "", "")
        }
    }, [selectVal])

    useEffect(() => {
        if (selectedReason?.length !== 0) {
            props?.updateState('brand_registered', "reason", '', selectedReason[0])
            props?.updateState('brand_registered', "brand_name", "", '')
        }
    }, [selectedReason, selectVal])

    async function checkIsSellerAlreadySelling() {
        isSellerAlreadySelling(props, {
            user_id: props.di?.user_id,
            shop_id: props?.redux?.current?.target?._id
        }).then((response) => {
            if (response?.success) {
                props?.updateState('seller_type', "", '', 'existing_seller')
            }
            else props?.updateState('seller_type', "", '', 'new_seller')
            props?.setAlredySellingDisabled(response?.success)
        })
    }

    function renderStructure() {
        return <div className="min__width560">
            <BlockStack gap="500">
                <BlockStack gap="200">
                    <Text as="h2" variant="headingMd">
                        {t("Step")}{' '}
                        <Text as="span">
                            {props.steps_completed + 1}
                            <Text as="span" tone="subdued">/3{' '}</Text>
                        </Text>{' '}
                        : {t("Which of the following best describes you?")}
                    </Text>
                    <Text as='p' tone='subdued'>{t("Choose any of the following that describes your sales journey on Amazon")}</Text>
                </BlockStack>
                <Divider />
                <BlockStack gap="300">
                    {Object.keys(props?.seller).map((key, index) => {
                        return (
                            <div key={index} className={`describe__field ${props?.seller?.[key]?.value ? 'active' : ''}`}>
                                <BlockStack gap="100">
                                    <Button
                                        onClick={() => {
                                            if (props?.seller[key]["value"]) {
                                                props.updateState('seller', key, 'value', false)
                                                props.updateState('seller', key, key === "manufacturer" ? 'brand_name' : 'other_type', "")
                                            } else
                                                props.updateState('seller', key, 'value', true)
                                        }}>
                                        {t(key?.replace("_", " ").charAt(0).toUpperCase() + key?.replace("_", " ").slice(1))}
                                    </Button>
                                    {
                                        props?.seller[key]?.value && key === 'manufacturer' &&
                                        <Box padding="300" background="bg-surface-secondary-active" borderRadius="100">
                                            <TextField
                                                label={t("Let us know your brand name")}
                                                placeholder={t("Enter brand name")}
                                                value={props?.seller?.manufacturer?.brand_name}
                                                onChange={(val: any) => props.updateState('seller', 'manufacturer', 'brand_name', val)}
                                                autoComplete="off"
                                                error={
                                                    props?.seller?.manufacturer?.value &&
                                                    props.errors.seller &&
                                                    props?.seller?.manufacturer?.brand_name?.trim() === '' &&
                                                    t('Kindly enter your brand name')
                                                }
                                            />
                                        </Box>
                                    }
                                    {
                                        props?.seller[key]?.value && key === 'others' &&
                                        <Box padding="300" background="bg-surface-secondary-active" borderRadius="100">
                                            <TextField
                                                label={t("Specify your business type")}
                                                value={props?.seller?.others?.other_type}
                                                onChange={(val: any) => {
                                                    props.updateState('seller', 'others', 'other_type', val);
                                                }}
                                                autoComplete="off"
                                                error={
                                                    props?.seller?.others?.value &&
                                                    props.errors?.seller &&
                                                    props?.seller?.others?.other_type?.trim() === '' &&
                                                    t('Kindly enter your business type')
                                                }
                                            />
                                        </Box>
                                    }
                                </BlockStack>
                            </div>
                        );
                    })}
                </BlockStack>
                {
                    props.errors['seller']
                    && !props?.seller?.manufacturer?.value
                    && !props?.seller?.drop_shipper?.value
                    && !props?.seller?.retailer?.value
                    && !props?.seller?.reseller?.value
                    && !props?.seller?.others?.value
                    && <Text as='p' tone='critical'>{t("Select atleast any one to proceed.")}</Text>
                }

                <BlockStack gap="500">

                    {renderExistingSellerDetails()}
                </BlockStack>
                <Button loading={props?.isLoading()} onClick={() => { props?.onSave() }} disabled={props?.['steps_completed'] == 0 ? true : false} variant='primary'>{props?.getFooterActionText()}</Button>
            </BlockStack>
        </div>;
    }

    function renderExistingSellerDetails() {
        return (
            <Box padding="500" borderRadius='100' background='bg'>
                <BlockStack gap="500">
                    <BlockStack gap="300">
                        <Text as="p" fontWeight="semibold">{t("Check these settings to manage your existing Amazon listings")}</Text>
                        <div className="existingAmazon">
                            <List type='number'>
                                <BlockStack gap={'150'}>
                                    <BlockStack gap="100">
                                        <List.Item>
                                            <InlineStack gap={'025'}>
                                                <Text as='p'>
                                                    {t("Deactivate product on Amazon when product is deleted from shopify.")}
                                                </Text>
                                                <Tooltip content={t("When you delete a product from Shopify, it will automatically be marked as 'out of stock' and become inactive on Amazon.")}><Icon source={InfoMinor} /> </Tooltip>

                                            </InlineStack>

                                        </List.Item>
                                        <BlockStack gap='100'>
                                            <RadioButton
                                                label={t("Yes")}
                                                checked={props.deactivateProduct === 'deactivateProduct_yes'}
                                                id="deactivateProduct_yes"
                                                name="deactivateProduct"
                                                onChange={(e) => {
                                                    props?.updateState('deactivateProduct', "", "", 'deactivateProduct_yes')
                                                    props?.errorHandler('deactivateProduct', false);
                                                }}
                                            />
                                            <RadioButton
                                                label={t("No")}
                                                id="deactivateProduct_no"
                                                name="deactivateProduct"
                                                checked={props.deactivateProduct === 'deactivateProduct_no'}
                                                onChange={(e) => {
                                                    props?.updateState('deactivateProduct', "", "", 'deactivateProduct_no');
                                                    props?.errorHandler('deactivateProduct', false);
                                                }}
                                            />
                                            {props?.errors?.deactivateProduct && <InlineError message={t("Kindly choose one")} fieldID="myFieldID" />}

                                        </BlockStack>

                                    </BlockStack>
                                    <BlockStack gap='300'>
                                        <Text as='p'>
                                            <List.Item>
                                                {t("Is your brand registered or approved by Amazon?")}
                                            </List.Item>
                                        </Text>
                                    </BlockStack>

                                    <BlockStack gap='300'>
                                        <Select label="" labelHidden value={selectVal} options={optionsOpt} onChange={(val: string) => { props?.errorHandler('not_registered_brand', false); setSelectVal(val) }} />
                                        {
                                            props?.brand_registered?.value == 'registered' &&
                                            <TextField
                                                label={t("Kindly copy same brand name(case sensitive) here")}
                                                value={props?.brand_registered?.brand_name || ""}
                                                onChange={(val: string) => {
                                                    props?.updateState('brand_registered', "brand_name", "", val);
                                                    props?.errorHandler('registered_brand', false);
                                                }}
                                                autoComplete="off"
                                                placeholder={t('Type your Brand name')}
                                                error={props?.errors?.registered_brand && t('Kindly fill the brand name')}
                                            />
                                        }

                                        {
                                            props?.brand_registered?.value == 'not_registered' &&
                                            <ChoiceList
                                                title={t("Brand not registered")}
                                                titleHidden
                                                choices={[
                                                    { label: t('Not applied yet'), value: 'not_applied' },
                                                    { label: t('Pending for approval from Amazon'), value: 'pending_approval' },
                                                    { label: t('Willing to sell with "Generic" in place of brand name'), value: 'willing_to_sell_generic' },
                                                ]}
                                                selected={selectedReason}      // not_applied | pending_approval | willing_to_sell_generic
                                                onChange={(value: string[]) => setSelectedReason(value)}
                                            />
                                        }
                                    </BlockStack>

                                    <BlockStack gap='300'>
                                        <Text as='p'>
                                            <List.Item>
                                                {t("Have you ever used an Integration App before this?")}
                                            </List.Item>
                                        </Text>
                                    </BlockStack>

                                    <BlockStack gap='100'>
                                        <RadioButton
                                            label={t("Yes")}
                                            checked={props.previousUsedApp === 'yes'}
                                            id="yes"
                                            name="accounts"
                                            onChange={(e) => {
                                                props?.updateState('previousUsedApp', "", "", 'yes')
                                                props?.errorHandler('previous_used_app', false);
                                                props?.errorHandler('previous_used_app_value', false);
                                            }}
                                        />
                                        <RadioButton
                                            label={t("No")}
                                            id="no"
                                            name="accounts"
                                            checked={props.previousUsedApp === 'no'}
                                            onChange={(e) => {
                                                props?.updateState('previousUsedApp', "", "", 'no');
                                                props?.errorHandler('previous_used_app', false);
                                                props?.errorHandler('previous_used_app_value', false);
                                            }}
                                        />
                                        {props?.errors?.previous_used_app && <InlineError message={t("Kindly choose one")} fieldID="myFieldID" />}

                                    </BlockStack>



                                    {props?.previousUsedApp === 'yes' && <><BlockStack gap='300'>
                                        <Text as='p'>
                                            {t("Please share name of the Integration Apps you have used previously.")}
                                        </Text>
                                    </BlockStack>
                                        <BlockStack gap='300'>
                                            <InlineStack>
                                                <PreviousAppInfo {...props} />
                                            </InlineStack>

                                        </BlockStack>

                                    </>
                                    }

                                    <BlockStack gap="300">
                                        <Text as='p'>
                                            <List.Item>
                                                {t("Select product details that you want to select/unselect before linking Amazon with Shopify listings. Please note, selecting any option might override your existing product information on  Amazon.")}
                                            </List.Item>
                                        </Text>
                                        <BlockStack gap="300">
                                            <BlockStack gap="100">
                                                <Checkbox
                                                    label={t("Price")}
                                                    checked={props?.settings_preferences?.price}
                                                    onChange={(event) => {
                                                        props.updateState('settings_preferences', 'price', '', event);
                                                    }}
                                                />
                                                <Checkbox
                                                    label={t("Inventory")}
                                                    checked={props?.settings_preferences?.inventory}
                                                    onChange={(event) => {
                                                        props.updateState('settings_preferences', 'inventory', '', event);
                                                    }}
                                                />
                                                <Checkbox
                                                    label={t("Product Details")}
                                                    checked={props?.settings_preferences?.product_details}
                                                    onChange={(event) => {
                                                        props.updateState('settings_preferences', 'product_details', '', event);
                                                    }}
                                                />
                                                <Checkbox
                                                    label={t("Images")}
                                                    checked={props?.settings_preferences?.images}
                                                    onChange={(event) => {
                                                        props.updateState('settings_preferences', 'images', '', event);
                                                    }}
                                                />
                                            </BlockStack>
                                        </BlockStack>
                                    </BlockStack>

                                </BlockStack>
                            </List>

                        </div>
                        <BlockStack gap='300'>
                                <Text as='p'>
                                    <Checkbox
                                        disabled={props.alredySellingDisabled}
                                        label={props.alredySellingDisabled ? t("We have found that you are an existing selller") : t("Do you currently have active listings on Amazon?")}
                                        id="existing_seller"
                                        name="accounts"
                                        checked={props?.['seller_type'] === 'existing_seller'}
                                        onChange={(val: any) => props?.['seller_type'] !== "existing_seller" ? props.updateState('seller_type', '', '', "existing_seller") : props.updateState('seller_type', '', '', "new_seller")}
                                    />
                                </Text>
                            </BlockStack>


                            {props?.['seller_type'] === 'existing_seller' && <BlockStack gap="300">
                                <BlockStack gap="300">
                                    <Text as="p">

                                        {t("Decide how you want to link your Amazon listings with Shopify listings along with the products fulfillment type. Our app matches products using SKUs or Barcodes. If your Shopify items have both SKUs and Barcodes, it's best to choose both for accurate linking.")}


                                    </Text>
                                    {
                                        (props?.fulfillment_settings?.['FBA']?.value && !props?.fulfillment_settings?.['FBM']?.value)
                                            ?
                                            (props?.fulfillment_settings?.['FBA']?.sku && props?.fulfillment_settings?.['FBA']?.barcode)
                                                ?
                                                <Box
                                                    padding="100"
                                                    background="avatar-four-bg-fill"
                                                    borderColor='border-secondary'
                                                    borderWidth='050'
                                                    borderRadius="100"
                                                >
                                                    <Text as='p'><strong>{t("Note:")}</strong> {t("Set the priority (in case you select both) by the drag and drop option.")}</Text>
                                                </Box>
                                                :
                                                <></>
                                            :
                                            (props?.fulfillment_settings?.['FBM']?.value && !props?.fulfillment_settings?.['FBA']?.value)
                                                ?
                                                (props?.fulfillment_settings?.['FBM']?.sku && props?.fulfillment_settings?.['FBM']?.barcode)
                                                    ?
                                                    <Box
                                                        padding="100"
                                                        background="avatar-four-bg-fill"
                                                        borderColor='border-secondary'
                                                        borderWidth='050'
                                                        borderRadius="100"
                                                    >
                                                        <Text as='p'><strong>{t("Note:")}</strong> {t("Set the priority (in case you select both) by the drag and drop option.")}</Text>
                                                    </Box>
                                                    :
                                                    <></>
                                                :
                                                (props?.fulfillment_settings?.['FBM']?.value && props?.fulfillment_settings?.['FBA']?.value) ?
                                                    (
                                                        (props?.fulfillment_settings?.['FBM']?.sku && props?.fulfillment_settings?.['FBM']?.barcode)
                                                        ||
                                                        (props?.fulfillment_settings?.['FBA']?.sku && props?.fulfillment_settings?.['FBA']?.barcode)
                                                    ) ?
                                                        <Box
                                                            padding="100"
                                                            background="avatar-four-bg-fill"
                                                            borderColor='border-secondary'
                                                            borderWidth='050'
                                                            borderRadius="100"
                                                        >
                                                            <Text as='p'><strong>{t("Note:")}</strong> {t("Set the priority (in case you select both) by the drag and drop option.")}</Text>
                                                        </Box>
                                                        :
                                                        <></>
                                                    : <></>
                                    }
                                    <BlockStack gap="100">
                                        <Checkbox
                                            error={props?.errors?.['sync_status_fulfillment']}
                                            label={t("FBA (Fulfilled By Amazon)")}
                                            checked={props?.fulfillment_settings?.['FBA']?.value}
                                            onChange={(event) => {
                                                props.updateState('fulfillment_settings', 'FBA', 'value', event);
                                                let error = !(props?.fulfillment_settings?.FBM?.value || event);
                                                props.errorHandler('sync_status_fulfillment', error);
                                            }}
                                        />
                                        {
                                            props?.fulfillment_settings?.['FBA']?.value &&
                                            <BlockStack gap="200">
                                                {(!props?.fulfillment_settings?.['FBA']?.sku && !props?.fulfillment_settings?.['FBA']?.barcode) && <InlineError message={t("Atleast one setting( i.e SKU or Barcode) is required")} fieldID="sync_status_with" />}
                                                <Draggable type='FBA' {...props} />
                                            </BlockStack>
                                        }
                                        <Checkbox
                                            error={props?.errors?.['sync_status_fulfillment']}
                                            label={t("FBM (Fulfilled By Merchant)")}
                                            checked={props?.fulfillment_settings?.['FBM']?.value}
                                            onChange={(event) => {
                                                props.updateState('fulfillment_settings', 'FBM', 'value', event);
                                                let error = !(props?.fulfillment_settings?.FBA?.value || event);
                                                props.errorHandler('sync_status_fulfillment', error);
                                            }}
                                        />
                                        {
                                            props?.fulfillment_settings?.['FBM']?.value &&
                                            <BlockStack gap="200">
                                                {(!props?.fulfillment_settings?.['FBM']?.sku && !props?.fulfillment_settings?.['FBM']?.barcode) && <InlineError message={t("Atleast one setting( i.e SKU or Barcode) is required")} fieldID="sync_status_with" />}
                                                <Draggable type='FBM' {...props} />
                                            </BlockStack>
                                        }
                                    </BlockStack>
                                    {props.errors[
                                        'sync_status_fulfillment'
                                    ] &&
                                        !props?.fulfillment_settings?.['FBA']?.value &&
                                        !props?.fulfillment_settings?.['FBM']?.value && (
                                            <Text as="p" tone="critical"> {t("Select atleast any one to proceed.")} </Text>
                                        )}
                                </BlockStack>
                            </BlockStack>}
                    </BlockStack>
                </BlockStack>
            </Box >
        );
    }

    return (
        renderStructure()
    );
}
export default DI(Stepthree);